const product = {
    getlist: 'BlogProduction/get-list',
    get: 'BlogProduction/get',
    add: 'BlogProduction/add',
    edit: 'BlogProduction/edit',
    remove: 'BlogProduction/remove',
}
export default product